"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixGuard = prefixGuard;
const navigation_1 = require("next/navigation");
const validators_1 = require("../validators/index.js");
function prefixGuard({ prefix, validPrefixes }) {
    try {
        return (0, validators_1.validatePrefix)({ prefix, validPrefixes });
    }
    catch {
        (0, navigation_1.notFound)();
    }
}
